<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {NuxtLayout, NuxtPage} from '#components';
    import {useHTMLAttrsLang, useSeoMeta} from '#imports';

    useHTMLAttrsLang();
    useSeoMeta({robots: 'noindex'});
</script>
